import * as XLSX from 'xlsx';

const TEXT_COLUMN_NAMES = new Set([
  'sirereg',
  'donorreg',
  'regnumber',
  'registrationnumber',
]);

export const generateExcelFile = (
  headers: string[],
  data: (string | number | null | undefined)[][],
  filename: string,
  columnWidths?: { wch: number }[],
) => {
  const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);

  if (columnWidths) {
    ws['!cols'] = columnWidths;
  }

  const headerStyle = {
    font: { bold: true, color: { rgb: 'FFFFFF' } },
    fill: { fgColor: { rgb: '376092' } },
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
  };

  for (let i = 0; i < headers.length; i++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: i });
    ws[cellAddress].s = headerStyle;
  }

  const textColumnIndices = headers.reduce<number[]>((acc, header, i) => {
    if (TEXT_COLUMN_NAMES.has(header.toLowerCase().replace(/\s+/g, '')))
      acc.push(i);
    return acc;
  }, []);

  for (const colIdx of textColumnIndices) {
    for (let rowIdx = 1; rowIdx <= data.length; rowIdx++) {
      const cellAddress = XLSX.utils.encode_cell({ r: rowIdx, c: colIdx });
      if (ws[cellAddress]) {
        ws[cellAddress].t = 's';
        ws[cellAddress].v = String(ws[cellAddress].v ?? '');
      }
    }
  }

  const lastCol = XLSX.utils.encode_col(headers.length - 1);
  ws['!autofilter'] = { ref: `A1:${lastCol}1` };

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Embryos');

  XLSX.writeFile(wb, filename);
};

export const convertToCSV = (data: Record<string, string | number>[]) => {
  const headers = Object.keys(data[0]).join(',');
  const rows = data.map((row) => Object.values(row).join(','));
  return [headers, ...rows].join('\n');
};

export const downloadCSV = (content: string, fileName: string) => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const formatUrlPathToTitle = (url: string): string | undefined => {
  const titleMatch = url.match(/\/([^/]+)$/);
  if (!titleMatch) return undefined;

  return titleMatch[1]
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const calculateTotalAllocatedEmbryos = (data: any) => {
  const shipped = parseInt(data?.shipped || '0');
  const shippedTog = parseInt(data?.shippedTog || '0');
  const heldAtTogToFreeze = parseInt(data?.heldAtTogToFreeze || '0');
  const heldAtTogFreezeTransferLowGrade = parseInt(
    data?.heldAtTogFreezeTransferLowGrade || '0',
  );
  const heldAtTogForTransfer = parseInt(data?.heldAtTogForTransfer || '0');
  return (
    shipped +
    shippedTog +
    heldAtTogToFreeze +
    heldAtTogFreezeTransferLowGrade +
    heldAtTogForTransfer
  );
};

export const calculateTotalEmbryos = (data: any) => {
  return (
    parseInt(data?.predictedGood || '0') +
    parseInt(data?.predictedVeryLow || '0')
  );
};
